import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  Action,
  createAction,
  createReducer,
  props,
  on,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { Avancement, IAvancement } from '../../_models/Avancement';
import { IEvenementSpontane } from '../../_models/EvenementSpontane';

export const name = 'avancements';

export interface AvancementState extends EntityState<IAvancement> {
  selectedId: number | null;
  isInitialized: boolean;
  loading: boolean;
}

function selectAvancement(a: IAvancement): any {
  return a.id;
}

function sortById(a: IAvancement, b: IAvancement): number {
  if (a.id < b.id) {
    return -1;
  } else if (a.id > b.id) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<IAvancement> = createEntityAdapter<IAvancement>({
  selectId: selectAvancement,
  sortComparer: sortById,
});

const initialState: AvancementState = adapter.getInitialState({
  selectedId: null,
  isInitialized: false,
  loading: true,
});

/* ACTION */
export const loadAvancementsAction = createAction(
  '[Avancement] Load Avancements',
  props<{ force: boolean }>()
);
export const loadAvancementsErrorAction = createAction(
  '[Avancement] Load Avancements Error'
);
export const loadAvancementsSuccessAction = createAction(
  '[Avancement] Load Avancements Success',
  props<{ payload: IAvancement[] }>()
);
export const setAvancementsAction = createAction(
  '[Avancement] Set Avancements Success',
  props<{ payload: IAvancement[] }>()
);

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadAvancementsSuccessAction, (state, { payload }) => {
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      loading: false,
    });
  }),
  on(loadAvancementsErrorAction, (state) => {
    return { ...state, loading: false };
  }),
  on(setAvancementsAction, (state, { payload }) => {
    return adapter.setAll(payload, state);
  })
);

export function avancementReducer(
  state: AvancementState | undefined,
  action: Action
): AvancementState {
  return reducer(state, action);
}

/* SELECTOR */
const selectAvancementState = createFeatureSelector<AvancementState>(name);

const isInitialized = (state: AvancementState) => state.isInitialized;
export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const selectAllAvancements = createSelector(
  selectAvancementState,
  (state) => {
    return state.loading
      ? undefined
      : state.ids.map((id: any) => new Avancement(state.entities[id]));
  }
);
export const selectIsAvancementInitialized = createSelector(
  selectAvancementState,
  isInitialized
);

export const selectAvancementsByEs = (es: IEvenementSpontane) =>
  createSelector(selectAllAvancements, (avancements) => {
    return avancements
      ? avancements.filter((x) =>
          es.pgm && es.pgm.idMode === 4 ? x.numeroPgm === es.pgm.numero : false
        )
      : [];
  });
